module.exports = __webpack_public_path__ + "img/01_TNP_White_zweizeilig.ecfd8594.svg";